export default function about_us() {
    console.log('%c Sakurairo %c https://github.com/mirai-mamori/Sakurairo', 'background: linear-gradient(to bottom right, #9FD5F7, #F1CAFF);color:#fff', '');
    console.log('だからもう\n' +
        '奇跡待たなくてもいいの\n' +
        '飛び込んで　会いに来て\n' +
        '渚の果て　何度でも\n' +
        '歌うから\n' +
        'いつか想いが叶うまで\n' +
        '波の翼のマーメイド\n' +
        '連れてって\n' +
        'きらめく橋の向こうまで\n' +
        '一緒に\n' +
        '%c ⌜Seaside Vacation⌟', 'background: linear-gradient(to bottom right, #9FD5F7, #F1CAFF);color:#fff');
}
